const fcdv = require('./components');
const req = require.context('./components', true, /^\.\/locale-provider\/(?!__tests__).+_.+\.js$/);

fcdv.locales = {};

req.keys().forEach(mod => {
  const match = mod.match(/\/([^/]+).js$/);
  fcdv.locales[match[1]] = req(mod).default;
});

module.exports = fcdv;
